import { LogLevel } from '@nts/std/utility';


export const environment = {
  production: false,
  baseAppUrl: 'https://ntsspoolservice.ntsinformatica.it/',
  authenticationAppUrl: 'https://ntsloginservice.ntsinformatica.it/auth/login',
  prefixApi: '/api',
  envType: 'DEV',
  appTitle: 'SpoolService - DEV',
  appSubTitle: '',
  logLevel: LogLevel.All,
  isEnterpriseBarrierRequired: false
};
